import React from 'react';
import type { Table } from '@tanstack/react-table';

import Select from 'components/partials/select/select';
import type { TableAmountState } from 'components/partials/table-component/table-component';

interface PageSizeOption {
  value: string;
  label: string;
}

const pageSizes: PageSizeOption[] = [
  { value: '10', label: '10' },
  { value: '20', label: '20' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
];

interface ViewByAmountSelectProps {
  table: Table<unknown>;
  pageSize: number;
  setAmount: ((updater: (state: TableAmountState) => TableAmountState) => void) | undefined;
}

export const ViewByAmountSelect = ({ table, pageSize, setAmount }: ViewByAmountSelectProps): React.JSX.Element => {
  const selectId = 'page-size-select';

  return (
    <div
      className="flex items-center gap-2"
      data-testid="view-amount-section"
    >
      <label htmlFor={selectId} className="text-base text-gray-500 whitespace-nowrap">
        View
      </label>
      <div>
        <Select
          labelFor={selectId}
          isSearchable={false}
          selectClass="w-[76px]"
          classNamePrefix="select"
          options={pageSizes}
          value={pageSizes.filter((option) => Number(option.value) === pageSize)}
          onChange={(e) => {
            if (!setAmount || !e || Array.isArray(e)) return;

            const numValue = Number(e.value);

            setAmount((state) => ({
              ...state,
              pageSize: numValue,
            }));
            table.setPageSize(numValue);
          }}
          extraBasicStyles={{ padding: 0, height: 2 }}
          aria-label="Number of items per page"
        />
      </div>
    </div>
  );
};
